module.exports = __webpack_public_path__ + "static/img/9.3.2675bd5e.png";